export type ReactNativeWindow = Window & { ReactNativeWebView?: { postMessage: (message: string) => void } };

/**
 * Posts a JSON message to the React Native WebView bridge.
 * Returns true if the message was sent successfully, false if the bridge is unavailable.
 */
export const postMessageToNative = (payload: Record<string, unknown>): boolean => {
    const currentWindow = globalThis.window as ReactNativeWindow;
    if (!currentWindow.ReactNativeWebView || typeof currentWindow.ReactNativeWebView.postMessage !== "function") {
        return false;
    }

    try {
        currentWindow.ReactNativeWebView.postMessage(JSON.stringify(payload));
    } catch {
        return false;
    }

    return true;
};

export const isNativeBridgeAvailable = (): boolean => {
    const currentWindow = globalThis.window as ReactNativeWindow;
    return Boolean(currentWindow.ReactNativeWebView && typeof currentWindow.ReactNativeWebView.postMessage === "function");
};
